import { render } from "./Landing.vue?vue&type=template&id=4831f452&scoped=true&ts=true"
import script from "./Landing.vue?vue&type=script&lang=ts"
export * from "./Landing.vue?vue&type=script&lang=ts"

import "./Landing.vue?vue&type=style&index=0&id=4831f452&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4831f452"]])

export default __exports__